import { BoxProps } from '@chakra-ui/react';
import { FEATURE_FLAGS } from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';
import { ICreatorLocation } from '~/types';

import { SearchLocationLegacy } from './SearchLocationLegacy';
import { SearchLocationNew } from './SearchLocationNew';
import { CreatorLocationDetail, ILocation } from './types';

interface SearchLocationProps extends Omit<BoxProps, 'onError'> {
  setValues: (creatorLocation: ICreatorLocation) => void;
  onError?: (error?: boolean) => void;
  trackId?: string;
  values?: ICreatorLocation;
  isSmartData?: boolean;
  isLoading?: boolean;
  inputProps?: {
    clearButtonProps?: {
      'aria-label': string;
      'track-id': string;
    };
  };
}

export const SearchLocation: React.FC<SearchLocationProps> = ({
  values,
  setValues,
  onError,
  ...props
}) => {
  const { isEnabled: isFoamTalentLocationFFEnabled } = useFeature(
    FEATURE_FLAGS.foamTalentLocation,
  );

  return isFoamTalentLocationFFEnabled ? (
    <SearchLocationNew
      creatorLocation={values as CreatorLocationDetail}
      setCreatorLocation={setValues}
      onError={onError}
      {...props}
    />
  ) : (
    <SearchLocationLegacy
      values={values as ILocation}
      setValues={setValues}
      {...props}
    />
  );
};
